<template>
  <div class="plans-filter-rooms">
    <div class="plans-filter-rooms__label">Комнатность</div>
    <ul class="plans-filter-rooms__list">
      <li
        v-for="room in roomsFilter"
        :key="room"
        :class="{
          'plans-filter-rooms__item': true,
          active: roomsFilterActive.includes(room),
        }"
      >
        <button type="button" @click="roomsFilterControl(room)">
          {{ room === "0" ? "Ст" : room }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  inject: ["filterStore"],

  props: {
    roomsFilter: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    roomsFilterActive() {
      const value = this.filterStore.state.filterRooms;
      if (!value) return [];
      if (Array.isArray(value)) return value;
      if (typeof value === 'string') {
        return value.includes(',') ? value.split(',') : [value];
      }
      return [];
    },
  },

  methods: {
    roomsFilterControl(value) {
      const current = [...this.roomsFilterActive];
      const index = current.indexOf(value);
      if (index > -1) {
        current.splice(index, 1);
      } else {
        current.push(value);
      }
      this.filterStore.setFilterRooms(current.length > 0 ? current : null);
    },
  },
};
</script>

<style scoped>
.plans-filter-rooms {
  display: flex;
  flex-direction: column;
}

.plans-filter-rooms__label {
  margin-bottom: 14px;
  font-weight: 500;
  font-size: 14px;
  color: #291f1f;
}

.plans-filter-rooms__list {
  display: flex;
  flex-wrap: nowrap;
  gap: 14px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.plans-filter-rooms__item button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 53px;
  width: 100%;
  height: 53px;
  padding: 20px;
  border: 1px solid #54586333;
  border-radius: 67px;
  background: #fff;
  color: #545863;
  transition: all 0.2s;
  cursor: pointer;
  font-weight: 500;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

.plans-filter-rooms__item button:focus {
  outline: none;
}

@media (hover: hover) and (pointer: fine) {
  .plans-filter-rooms__item button:hover {
    background: linear-gradient(135deg, #d3d0ff, #ff0020, #fff);
    color: #fff;
  }
}

.plans-filter-rooms__item.active button,
.plans-filter-rooms__item.active button:hover,
.plans-filter-rooms__item.active button:focus {
  background: linear-gradient(135deg, #d3d0ff, #ff0020, #fff);
  color: #fff;
  border: none;
}
</style>
